import { Component, OnInit, OnDestroy, Input } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() padding: boolean;
  @Input() size: string;
  panelClass = '';
  modalOpen: boolean;

  constructor() { }

  ngOnInit() {
    const $body = document.body;
    // $body.classList.add("disable-scroll");
    if(this.size === undefined){
      this.size = '';
    }else{
      this.size = 'modal-dialog-' + this.size;
    }

    if (this.padding){
      this.panelClass = 'panel-body';
    }
  }

  ngOnDestroy() {
    const $body = document.body;
    // $body.classList.remove("disable-scroll");
  }

  toggle(){
    this.modalOpen = !this.modalOpen;
    const $body = document.body;
    
    if(!this.modalOpen && $body.classList.contains("modal-open")) {
      $body.classList.remove("modal-open");
    }

    if(this.modalOpen) {
      $body.classList.add("modal-open");
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/modal.component.ts